import { apiIsomorphicFetchUserEnvironment } from '#/api/userEnvironment/apiFetchUserEnvironment';
import { redirectRequireAuthentication } from '#/modules/auth/routing/redirect-require-authentication';
import type { orgDashboardGradfairsLinksRoute } from '#/modules/orgDashboard/routing/org-select.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { GradFairsLinksLoadable } from './GradFairsLinksLoadable';

export async function loader({
  request,
  context,
}: HorizonAppRouteLoaderArgs<typeof orgDashboardGradfairsLinksRoute>) {
  const [{ user }] = await Promise.all([
    apiIsomorphicFetchUserEnvironment({
      request,
      context,
    })(),
    GradFairsLinksLoadable.load(),
  ]);

  if (!user) return redirectRequireAuthentication({ request });
}

export default function OrgDashboardGradFairsLinksHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <GradFairsLinksLoadable />;
}
